import moment from "moment";
import TicketStatusLabel from "./TicketStatusLabel";

function TicketHistoryItem({ ticket }) {
  const { ticket_id, description, order_status, created_at, order_id, status } =
    ticket;

  return (
    <div className="relative p-5 text-[10px] font-custom bg-white rounded-[20px] shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)]">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-stone-500 font-medium">
          Ticket ID:{" "}
          <span className="text-stone-900 font-bold">{ticket_id}</span>
        </div>

        <TicketStatusLabel status={status} />
      </div>

      {/* Body */}
      <div className="mt-2 text-xs">
        <div className="text-stone-900 font-semibold">Query:</div>
        <div className="text-stone-500 font-medium">{description}</div>
      </div>

      {/* Footer */}
      <div className="flex mt-3 justify-between items-center text-[10px] text-stone-500 font-medium">
        <div className="flex items-center">
          <div className="mr-3">
            Order ID:{" "}
            <span className="text-stone-900 font-bold">
              {order_id ?? "N/A"}
            </span>
          </div>

          <div>
            Date:{" "}
            <span className="text-stone-900 font-semibold">
              {moment(created_at).format("DD/MM/YY")}
            </span>
          </div>
        </div>
        <a href={`/view-ticket/${ticket_id}`} className="block">
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.251051 11.7489C-0.0836838 11.4142 -0.0836839 10.8715 0.251051 10.5368L4.78782 6L0.251051 1.46323C-0.0836843 1.1285 -0.0836843 0.585785 0.251051 0.25105C0.585786 -0.0836859 1.1285 -0.083686 1.46323 0.25105L6.60609 5.39391C6.94083 5.72864 6.94083 6.27136 6.60609 6.60609L1.46323 11.7489C1.1285 12.0837 0.585786 12.0837 0.251051 11.7489Z"
              fill="#1E1E1E"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}

export default TicketHistoryItem;
